// extracted by mini-css-extract-plugin
export var dsBody = "Datenschutz-module--dsBody--YhGBN";
export var dsContainer = "Datenschutz-module--dsContainer--i6sEj";
export var dsHead = "Datenschutz-module--dsHead--k12z3";
export var dsSubhead = "Datenschutz-module--dsSubhead--0orsb";
export var dsWrapper = "Datenschutz-module--dsWrapper--2cHK6";